/**
 * Removes trailing slash from URL to prevent double slashes when concatenating paths
 * @param url - The base URL that might have a trailing slash
 * @returns URL without trailing slash
 */
export const normalizeApiUrl = (url: string): string => {
    return url.endsWith('/') ? url.slice(0, -1) : url;
};

/**
 * Constructs a full API endpoint URL by combining base URL and path
 * @param baseUrl - The base API URL
 * @param path - The endpoint path (should start with /)
 * @returns Complete endpoint URL
 */
export const buildApiUrl = (baseUrl: string, path: string): string => {
    const normalized = normalizeApiUrl(baseUrl);
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${normalized}${normalizedPath}`;
};
